import React, { useEffect } from "react";
import { any } from "prop-types";

import { PopupButton } from "@typeform/embed-react";

import CoverPorfolio from "../../components/cover-portfolio";

import { LargeText, SmallTitle } from "../../ui-components/texts";

// import PeopleOfMasamune from "../../components/people-of-masamune";
import { DetailsProject } from "../../components/portfolio-components";
import {
	Column,
	Container,
	ContainerBlock,
} from "../../ui-components/columns/components";

// images
import imageCover from "../../media/images/portfolio-images/micidial/cover.jpg";
import { TitleWithScrollXImagesSection } from "./components-design";
import PeopleOfMasamune from "../../components/people-of-masamune";
import { useTranslate } from "../../contexts/translate";

const Micidial = ({
	setNextPageHref = () => {},
	setNextPageName = () => {},
}) => {
	const { translations } = useTranslate();
	useEffect(() => {
		setNextPageHref("/projects/world-padel-store");
		setNextPageName("World Padel Store");
		document.title = 'Micidial - Cutting Edge Digital Creative Studio'
	}, []);

	const peoples = [
		{
			fullname: "Simone Scalia",
			image: require("../../media/team-images/Simone Scalia.jpg").default,
			role: translations === null ? "" : translations.about.peoples[7].role,
			description:
				translations === null ? "" : translations.about.peoples[7].description,
		},
		{
			fullname: "Andrea Bolloni",
			image: require("../../media/team-images/Andrea Bolloni.jpg").default,
			role: translations === null ? "" : translations.about.peoples[6].role,
			description:
				translations === null ? "" : translations.about.peoples[6].description,
		},
		{
			fullname: "Michele Giacchè",
			image: require("../../media/team-images/no-image.png").default,
			role: "Brand Designer",
			description: "",
		},
	];

	return (
		<div className="project-page project-page-ohoskin">
			<CoverPorfolio
				background="#f5f9ff"
				title="Micidial - House of Maccio"
				text={translations && translations.micidial.intro}
				image={imageCover}
			/>

			<DetailsProject
				client={"Micidial"}
				services={["Photography", "Corporate & Visual Identity"]}
				timeframe={"2020"}
				introduction={
					<>
						<LargeText>
							{translations && translations.micidial.descriptions[0]}
						</LargeText>
						<LargeText>
							{translations && translations.micidial.descriptions[1]}
						</LargeText>
					</>
				}
			/>

			<section
				className="theme-light mid-padding"
				style={{ background: "#fff" }}
			>
				<Container>
					<div className="wrapper fluid align-items-center">
						<Column className="w-50">
							<img
								src={
									require("../../media/images/portfolio-images/micidial/1.jpg")
										.default
								}
								alt="Image"
							/>
						</Column>
						<Column className="w-50">
							<SmallTitle>{translations && translations.micidial.sections[0].title}</SmallTitle>
							<LargeText>
								{translations && translations.micidial.sections[0].text}
							</LargeText>
						</Column>
					</div>
				</Container>
			</section>

			<TitleWithScrollXImagesSection
				color={"#1e092e"}
				className="theme-dark"
				title={translations && translations.micidial.sections[1].title}
				text={translations && translations.micidial.sections[1].text}
				items={[
					{
						src: require("../../media/images/portfolio-images/micidial/2.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/micidial/3.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/micidial/4.png")
							.default,
					},
					{
						src: require("../../media/images/portfolio-images/micidial/5.png")
							.default,
					},
				]}
			/>

			<PeopleOfMasamune peoples={peoples} />
				<div className="cta-single-project">
				<div className="cta-single-project-inner">
					<p>{translations && translations.ctasingleproject.text}</p>
					<button
						className="leadconnector-button"
						onClick={() => {
							const overlay = document.createElement("div");
							overlay.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													background-color: rgba(0, 0, 0, 0.7);
													backdrop-filter: blur(5px);
													z-index: 9998;
												`;

							const modal = document.createElement("div");
							modal.style.cssText = `
													position: fixed;
													top: 0;
													left: 0;
													width: 100%;
													height: 100%;
													z-index: 9999;
												`;

							const closeBtn = document.createElement("button");
							closeBtn.innerHTML = "✕";
							closeBtn.style.cssText = `
													position: fixed;
													top: 30px;
													right: 30px;
													width: 50px;
													height: 50px;
													border: none;
													background-color: rgba(255, 255, 255, 0.2);
													color: white;
													border-radius: 50%;
													cursor: pointer;
													font-size: 28px;
													z-index: 10000;
													transition: all 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
													backdrop-filter: blur(10px);
													border: 1px solid rgba(255, 255, 255, 0.3);
													display: flex;
													align-items: center;
													justify-content: center;
												`;
							closeBtn.onmouseover = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.3)";
								closeBtn.style.transform = "scale(1.15) rotate(90deg)";
								closeBtn.style.boxShadow = "0 8px 32px rgba(0, 0, 0, 0.3)";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.5)";
							};
							closeBtn.onmouseout = () => {
								closeBtn.style.backgroundColor = "rgba(255, 255, 255, 0.2)";
								closeBtn.style.transform = "scale(1) rotate(0deg)";
								closeBtn.style.boxShadow = "none";
								closeBtn.style.borderColor = "rgba(255, 255, 255, 0.3)";
							};
							closeBtn.onclick = () => {
								overlay.style.opacity = "0";
								modal.style.opacity = "0";
								overlay.style.transition = "opacity 0.4s ease-out";
								modal.style.transition = "opacity 0.4s ease-out";
								setTimeout(() => {
									document.body.removeChild(overlay);
									document.body.removeChild(modal);
								}, 400);
							};

							const iframe = document.createElement("iframe");
							iframe.src =
								"https://api.leadconnectorhq.com/widget/survey/fXRdOm9p3aM4iNGpHfOa?notrack=true";
							iframe.style.cssText = `
													width: 100%;
													height: 100%;
													border: none;
												`;
							iframe.allowFullscreen = true;

							modal.appendChild(iframe);
							modal.appendChild(closeBtn);
							document.body.appendChild(overlay);
							document.body.appendChild(modal);

							overlay.onclick = () => {
								document.body.removeChild(overlay);
								document.body.removeChild(modal);
							};
						}}
					>
						{translations && translations.ctasingleproject.button}
					</button>
				</div>
			</div>
		</div>
	);
};

Micidial.propTypes = {
	setNextPageHref: any,
	setNextPageName: any,
};

export default Micidial;
